import { useContext } from "react";
import { motion } from "framer-motion";
import LanguageContext from "../components/LanguageContext";

function About() {
  const { t, lang } = useContext(LanguageContext);

  return (
    <motion.div
      className="page"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    >
      {/* About Section */}
      <h2 className="section-title">{t.aboutTitle}</h2>
      <p className="section-intro">{t.aboutText1}</p>

      <div className="about-highlights">
        {(t.aboutHighlights || []).map((item, i) => (
          <div key={i} className="about-highlight-card">
            <span className="about-highlight-text">{item.text}</span>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div className="about-divider">
        <span>{lang === 'zh' ? '欢迎光临 · 期待为您服务' : 'We look forward to serving you'}</span>
      </div>

      {/* Contact Section */}
      <div className="about-contact-section">
        <div className="contact-columns">
          <div className="contact-column">
            <div className="contact-header">
              <h2 className="section-title">{t.contactTitle}</h2>
              <p className="section-intro">{t.contactText}</p>
            </div>
            <div className="contact-box contact-card">
              <p><strong>📞 {t.phoneLabel}:</strong> (65) 8333 9889</p>
              <p><strong>🕒 {t.hoursLabel}:</strong> 9:30 AM – 9:30 PM</p>
              <p><strong>💳 {t.paymentLabel}:</strong> {t.paymentLabels}</p>
              <a href="tel:83339889" className="primary-btn full-width">
                {t.callNow}
              </a>
            </div>
          </div>

          <div className="contact-column">
            <div className="contact-header">
              <h2 className="section-title">{t.findUsTitle}</h2>
              <p className="section-intro">{t.findUsSubtitle}</p>
            </div>
            <div className="location-box contact-card">
              <p>
                <strong>📍 {t.addressLabel}: </strong>
                1 Park Road #03-40B<br />
                People's Park Complex S(059108)
              </p>
              <div className="map-card">
                <iframe 
                title="Xin Yu Wellness Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8143174790603!2d103.8431707!3d1.2853980999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1b006484a56b%3A0x351c8b506781950a!2zWGluIFl1IFlhbmcgU2hlbiBHdWFuIHwg5b-D5oSI5YW755Sf6aaG!5e0!3m2!1sen!2ssg!4v1773147379542!5m2!1sen!2ssg"
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade">
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default About;